// extracted by mini-css-extract-plugin
export default {"tab":"tab-DMKHo","activeTab":"activeTab-HQ5d1","tabsRow":"tabsRow-yi9Kw","tabsLine":"tabsLine-QYCUr","disabledTab":"disabledTab-PJ5_n"};